import { Expose, Type } from 'class-transformer';
import { BaseEntity } from './base.entity';
import { InstallationEventEntity } from './installation-event.entity';

export class InstallationEventListEntity extends BaseEntity {
  @Expose()
  @Type(() => InstallationEventEntity)
  public events: InstallationEventEntity[];
}
